import { useContext, useEffect, useRef, useState } from "react";
import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { useLocation, useNavigate } from "react-router-dom";
import TkStepper from "../../components/atoms/TkStepper";
import { Box } from "@mui/material";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { fakeTableList, stepperData } from "./parts";
import { httpAPI_RET002, httpRequestsToUseTotalSystem } from "./api/request";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import { IAPI_RET002_Response, IAPI_RET003_Request } from "../../type/apiType";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { changeZipcodeFormat } from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";
import { Prefectures, RetireReason, Status } from "../../assets/data/Constants";
import _ from "lodash";

/**
 * SCRR410017合算制度利用申出の手続き（機構への提出確認）
 * 合算制度利用手続き 機構への提出確認提出前に登録されている情報を確認する。
 * @return SCRR410017
 */
const SCRR410017 = () => {
  const navigate = useNavigate();
  const location = useLocation();

  //グローバルContextを更新するState
  const { state, setState } = useContext(GlobalContext);
  //ユーザータイプが機構職員の場合に出す契約者（法人）名が入ったfakeTableList
  const [stateFakeTableList, setStateFakeTableList] = useState<any>([]);
  //機構へ提出するボタンのflug:true表示、false非表示
  const [openSuccess, setOpenSuccess] = useState(false);
  //業務用Contextを更新するState
  const { state: businessState } = useContext(BusinessContext);
  //持回情報.一時保存ステップのStepperを状態管理するState
  const [checkAndSubmitstepper] = useState<number>();
  const userType = state.authInfo?.userType;
  const contractorNo =
    userType === authorityUserType.userTypeNumber.KIKO
      ? businessState?.common?.contractorNo
      : state?.authInfo?.contractorNo;

  const applyId = location.state?.applyId;
  const [status, setStatus] = useState<any>("00");
  const [showSubmitButton, setShowSubmitButton] = useState(true);
  const stateFakeTableListCp = useRef(_.cloneDeep(fakeTableList));

  useEffect(() => {
    let resArr = stateFakeTableListCp.current;

    if (userType === authorityUserType.userTypeNumber.KEIYAKUSYA) {
      //代行者メールアドレス
      let agentemail = resArr.find((item) => item.keyword === "agentemail")!;
      agentemail.text = businessState?.job_36?.agentEmail;
      agentemail.showLine = true;
    }
    if (userType === authorityUserType.userTypeNumber.KIKO) {
      //契約者(法人)名
      let contractorname = resArr.find(
        (item) => item.keyword === "contractorname"
      )!;
      contractorname.text =
        businessState?.common?.contractorNo +
        ":" +
        businessState?.job_36?.contractorName;
      contractorname.showLine = true;
    }
    setStateFakeTableList([...resArr]);

    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // 初期化
  const handleInit = async () => {
    try {
      let resArr = stateFakeTableListCp.current;
      let facilityname = resArr.find(
        (item) => item.keyword === "facilityname"
      )!;
      let staffNamekanji = resArr.find(
        (item) => item.keyword === "staffNamekanji"
      )!;
      let birthday = resArr.find((item) => item.keyword === "birthday")!;
      let maePerioddate = resArr.find(
        (item) => item.keyword === "maePerioddate"
      )!;
      let retiredate = resArr.find((item) => item.keyword === "retiredate")!;
      let retireProcedurereason = resArr.find(
        (item) => item.keyword === "retireProcedurereason"
      )!;
      let zipcode = resArr.find((item) => item.keyword === "zipcode")!;
      let address = resArr.find((item) => item.keyword === "address")!;
      let tel = resArr.find((item) => item.keyword === "tel")!;
      let email = resArr.find((item) => item.keyword === "email")!;
      let apiRes: IAPI_RET002_Response | undefined = undefined;
      if (applyId) {
        // 振込情報詳細参照
        const res = await httpAPI_RET002({
          applyId: applyId,
          contractorNo: contractorNo,
        });
        if (res.resultCd === "I0000") {
          apiRes = res;
          setStatus(res?.latestApplyStatus);
          const prefecture = TkGetCode(Prefectures, res?.prefectureCd);
          facilityname.text =
            (res?.facilityNo ?? "") + ":" + (res?.facilityName ?? "");
          staffNamekanji.text = res?.staffNameKanji;
          birthday.text = res?.birthday;
          maePerioddate.text =
            (res?.maePeriodYear ?? "") +
            "年" +
            (res?.maePeriodMonth ?? "") +
            "月";
          retiredate.text = res?.retireDate;
          retireProcedurereason.text = TkGetCode(
            RetireReason,
            res?.retireProcedureReason
          );
          zipcode.text = changeZipcodeFormat(res?.zipcode);
          address.text = `${prefecture ?? ""}${res?.addressCity ?? ""}${
            (res?.addressOthers ? res?.addressOthers : "") ?? ""
          }`;
          tel.text = res?.tel;
          email.text = res?.email;

          if (
            res.latestApplyStatus !== "00" &&
            res.latestApplyStatus !== "16"
          ) {
            setShowSubmitButton(false);
          }
        } else {
          setState({
            ...state,
            errorMsgId: res?.resultCd,
          });
        }
      } else {
        const prefecture = TkGetCode(
          Prefectures,
          businessState?.job_36?.prefectureCd
        );
        facilityname.text =
          (businessState?.job_36?.facilityNo ?? "") +
          ":" +
          (businessState?.job_36?.facilityName ?? "");
        staffNamekanji.text = businessState?.job_36?.staffName;
        birthday.text = businessState?.job_36?.birthday;
        maePerioddate.text =
          (businessState?.job_36?.maePeriodYear ?? "") +
          "年" +
          (businessState?.job_36?.maePeriodMonth ?? "") +
          "月";
        retiredate.text = businessState?.job_36?.retireDate;
        retireProcedurereason.text = TkGetCode(
          RetireReason,
          businessState?.job_36?.retireProcedureReason
        );
        zipcode.text = changeZipcodeFormat(businessState?.job_36?.zipcode);
        address.text = `${prefecture ?? ""}${
          businessState?.job_36?.addressCity ?? ""
        }${businessState?.job_36?.addressOthers ?? ""}`;
        tel.text = businessState?.job_36?.tel;
        email.text = businessState?.job_36?.email;
      }

      const powerOfAttorney = resArr.find(
        (item) => item.keyword === "powerOfAttorney"
      );
      if (powerOfAttorney) {
        if (apiRes) {
          const powerOfAttorneyFile = apiRes.fileList?.find(
            (item) => item.formClass === "43"
          );
          powerOfAttorney.base64filedata = powerOfAttorneyFile?.fileBase64;
          powerOfAttorney.dataname = powerOfAttorneyFile?.fileName;
          powerOfAttorney.showLine = true;
        } else if (businessState?.job_36?.fileList) {
          const powerOfAttorneyFile = businessState?.job_36?.fileList?.find(
            (item) => item.formClass === "43"
          );
          powerOfAttorney.base64filedata = powerOfAttorneyFile?.file;
          powerOfAttorney.dataname = powerOfAttorneyFile?.formName;
          powerOfAttorney.showLine = true;
        }
      }

      setStateFakeTableList([...resArr]);
    } catch (error) {
      navigate("/error");
    }
  };

  const makeHttpObj = (): IAPI_RET003_Request => {
    return {
      applyId: businessState.job_36?.applyId, // 申請id
      staffNo: businessState.job_36?.staffNo as string, // 法人職員番号
      contractorNo: contractorNo as string, // 共済契約者番号
      facilityNo: businessState.job_36?.facilityNo as string, // 施設番号
      retireDate: businessState.job_36?.retireDate as string, // 退職年月日
      retireProcedureReason: businessState.job_36
        ?.retireProcedureReason as string, // 退職理由
      zipcode: businessState.job_36?.zipcode as string, // 住所（郵便番号）
      prefectureCd: businessState.job_36?.prefectureCd as string, // 住所（都道府県）
      addressCity: businessState.job_36?.addressCity as string, // 住所（市区町村）
      addressOthers: businessState.job_36?.addressOthers as string, // 住所（その他）
      tel: businessState.job_36?.tel as string, // 電話番号
      email: businessState.job_36?.email as string, // メールアドレス
      agentEmail: businessState.job_36?.agentEmail, // 代行者メールアドレス
      updateDateTime: businessState.job_36?.updateDatetime,
      screenId: "SCRR410017",
      fileList: businessState.job_36?.fileList?.map((item) => ({
        serialNo: item.serialNo,
        facilityNo: item.facilityNo,
        staffNo: item.fileList_staffNo,
        formKbn: item.formKbn,
        formClass: item.formClass,
        fileName: item.formName,
        fileBase64: item.file,
      })),
    };
  };

  //提出するボタン押下時に更新用APIを呼び出すイベント
  const handleOk = async (date?: any) => {
    try {
      const res = await httpRequestsToUseTotalSystem({
        ...makeHttpObj(),
        receptionDate: date,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        navigate("/SCRR411118");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });

        setOpenSuccess(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onCheckAndSubmit = () => {
    setOpenSuccess(true);
  };

  return (
    <Box data-testid="SCRR410017PageForTest">
      <TkStepper
        steps={stepperData}
        activeStep={status === "00" || status === "16" ? 2 : 3}
        savaStep={checkAndSubmitstepper}
      ></TkStepper>
      <Box>
        <TkInfoManual rule={"\\n"}>
          {labelids.labelid.LBLR410017_01}
        </TkInfoManual>
      </Box>
      <TkFakeTable
        list={stateFakeTableList}
        submitButtonText={
          status === Status["届出待ち"] || status === Status["差戻し一時保存"]
            ? userType === authorityUserType.userTypeNumber.KIKO
              ? "申請"
              : "機構へ提出する"
            : undefined
        }
        showButton={showSubmitButton}
        buttonGroup={<TkBackButton></TkBackButton>}
        ruleSchema={{}}
        onCheckAndSubmit={onCheckAndSubmit}
      />

      {userType === authorityUserType.userTypeNumber.KIKO ? (
        <TkDateDialog
          open={openSuccess}
          onOky={handleOk}
          onCancel={() => setOpenSuccess(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請します）"
          okText="はい"
          cancelText="いいえ"
          contextText="合算制度利用申込日を入力してください。"
        />
      ) : (
        <TkMessageDialog
          data-testid="TkMessageDialog"
          open={openSuccess}
          onCancel={() => setOpenSuccess(false)}
          onOky={handleOk}
          title="確認（機構へ提出します）"
          contextText="機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRR410017;
